import React, { useEffect, useState } from 'react';
import { Button, Modal, message, Space } from 'antd';
import SchemaForm from '../components/SchemaForm';
import SchemaList from '../components/SchemaList';
import { fetchSchemas, createSchema, updateSchema, deleteSchema } from '../services/schemaApi';
import {useToast} from "../ToastProvider";

export default function SchemaPage() {
    const [schemas, setSchemas] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingSchema, setEditingSchema] = useState(null);
    const { addToast } = useToast();
    const fetchData = async () => {
        const res = await fetchSchemas();
        setSchemas(res.data);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const openModal = (schema = null) => {
        setEditingSchema(schema);
        setModalOpen(true);
    };

    const handleSubmitSchema = async (schema) => {
        try {
            if (editingSchema?.id) {
                await updateSchema(schema);
                addToast('Đã cập nhật schema','success');
            } else {
                await createSchema(schema);
                addToast('Đã thêm mới schema','success');
            }
            setModalOpen(false);
            fetchData();
        } catch (e) {
            addToast('Lỗi xử lý schema','error');
        }
    };

    const handleDelete = async (schema) => {
        try {
            await deleteSchema(schema.id);
            addToast('Đã xóa schema','success');
            fetchData();
        } catch (e) {
            addToast('Không thể xóa','error');
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Space style={{ marginBottom: 16 }}>
                <Button type="primary" onClick={() => openModal()}>Thêm Schema</Button>
            </Space>

            <SchemaList schemas={schemas} onEdit={openModal} onDelete={handleDelete} />

            <Modal
                title={editingSchema ? 'Cập nhật Schema' : 'Thêm Schema'}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                destroyOnHidden
                width={1000}
            >
                <SchemaForm
                    handleSubmitSchema={handleSubmitSchema}
                    editingSchema={editingSchema}
                />
            </Modal>
        </div>
    );
}
